import { makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";
import { EPositions, ESize, ETheme } from "../common.interface";

interface IconProps {
  color?: ETheme;
  iconPlacement?: EPositions;
  iconSize?: ESize;
  width?: string;
  height?: string;
  blackThemed?: boolean;
}
export const StyledToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: ({ blackThemed }: IconProps) =>
      blackThemed ? theme.palette.common.black : theme.palette.common.white,
    color: ({ blackThemed }: IconProps) =>
      blackThemed ? theme.palette.common.white : theme.palette.text.primary,
    padding: theme.spacing(1),
    boxShadow: theme.shadows[2],
    fontSize: "12px",
    maxWidth: "220px",
  },
  arrow: {
    color: ({ blackThemed }: IconProps) =>
      blackThemed ? theme.palette.common.black : theme.palette.common.white,
  },
}))(Tooltip);

export const useHelpIconStyles = makeStyles(({ palette }: Theme) => ({
  root: {
    color: ({ color }: IconProps) =>
      color === "secondary" ? palette.secondary.main : palette.primary.main,
    marginLeft: ({ iconPlacement }: IconProps) =>
      iconPlacement === "end" ? "4px" : "0px",
    marginRight: ({ iconPlacement }: IconProps) =>
      iconPlacement === "start" ? "4px" : "0px",
    width: ({ iconSize, width = "18px" }: IconProps) => {
      switch (iconSize) {
        case "medium":
          return "20px";
        case "large":
          return "24px";
        case "custom":
          return width;
        default:
          return "18px";
      }
    },
    height: ({ iconSize, height = "18px" }: IconProps) => {
      switch (iconSize) {
        case "medium":
          return "20px";
        case "large":
          return "24px";
        case "custom":
          return height;
        default:
          return "18px";
      }
    },
  },
}));

export const Wrapper = withStyles({
  root: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
  },
})(Box);
